<template>
  <v-app>
    <v-main>
      <PlantillaLogin/>
    </v-main>
  </v-app>
</template>

<script>
import PlantillaLogin from '../templates/PlantillaLogin';

export default {
  name: 'App',

  components: {
    PlantillaLogin,
  },

  data: () => ({
    //
  }),
};
</script>
